import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { groups } from "../msalConfig";
import './../common.css'; // Import common CSS styles

function XioSupportToolPage() {
  const message1 = "SAAS Tool";
  const navigate = useNavigate();
  const { accounts } = useMsal();

  // Debug: Check user groups
  const userGroups = accounts[0]?.idTokenClaims?.groups || [];
  console.log("XioSupportToolPage - User Groups:", userGroups);
  console.log("XioSupportToolPage - Required Groups:", {
    EsOps: groups.EsOps,
    XioSupportToolsAtsgRW: groups.XioSupportToolsAtsgRW,
    XioSupportToolsAtsgRO: groups.XioSupportToolsAtsgRO,
    XioSupportToolsAtsgAdmin: groups.XioSupportToolsAtsgAdmin
  });

  function goToAtsgHome() {
    console.log("Attempting to navigate to /atsg/home");
    console.log("Current pathname:", window.location.pathname);
    navigate('/atsg/home');
    console.log("Navigation command executed");
  }

  return (
    <>
      <div className='supporttool-box shadow-xl shadow-cyan-500/30' >
          <div >
            <button
              onClick={goToAtsgHome}
              className={"supporttool-button rounded-md shadow-md shadow-cyan-500 w-48"}
            >
              {message1}
            </button>
          </div>
      </div>
  </>
  );
}

export default XioSupportToolPage;